import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import clsx from 'clsx';
import CollapseBody from './body';
import * as styles from './collapse.module.css';
import CollapseHeader from './header';
import '@hotmart-org-ca/cosmos/dist/collapse';
const Collapse = ({ onClick, children, startOpen = false, arrow = 'right' }) => {
    const initialStartOpen = useRef(startOpen);
    return (_jsx("div", { className: "border-b-small border-neutral-200", children: _jsx("hot-collapse", { onClick: onClick, ...(initialStartOpen.current && { active: '' }), class: clsx(styles.collapse, {
                'hot-collapse--arrow-start': arrow === 'left'
            }), children: children }) }));
};
Collapse.Header = CollapseHeader;
Collapse.Body = CollapseBody;
export default Collapse;
